<template>
  <div
    :class="componentClasses"
  >
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue';

const componentClasses = computed(() => [
  'stk-details-grid',
]);
</script>

<style>
.stk-details-grid {
  display: grid;
  gap: 0.5em 1em;
  grid-template-columns: repeat(auto-fit, minmax(10em, 1fr));
}
</style>
